export const getSlackTeamLink = (slackTeamDomainName?: string): string =>
  slackTeamDomainName ? `https://${slackTeamDomainName}.slack.com` : 'slack://open';

export const getSlackSignupLink = (slackTeamDomainName?: string): string =>
  slackTeamDomainName ? `https://${slackTeamDomainName}.slack.com/signup` : 'https://slack.com/get-started';
